import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/case/patient/")({
	component: RouteComponent,
});

function RouteComponent() {
	return "Hello /dashboard/case/patient/!";
}
